import React, { useState } from 'react';
import { Box, Typography, Paper, IconButton, Tooltip, Collapse } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const SqlPreviewPanel = ({ sql }) => {
  const [copied, setCopied] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(sql).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const handleToggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <Box sx={{ mt: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant='h6'>SQL Preview</Typography>
          <IconButton
            onClick={handleToggleExpand}
            size='small'
            sx={{ ml: 1 }}
          >
            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Box>
        <Tooltip title={copied ? 'Copied!' : 'Copy to clipboard'}>
          <IconButton
            onClick={handleCopyToClipboard}
            disabled={!sql}
            size='small'
          >
            {copied ? <CheckIcon color='success' /> : <ContentCopyIcon />}
          </IconButton>
        </Tooltip>
      </Box>
      <Collapse in={isExpanded}>
        <Paper
          sx={{
            p: 2,
            backgroundColor: '#f5f5f5',
            minHeight: 200,
            maxHeight: 400,
            overflow: 'auto',
            fontFamily: 'monospace',
            fontSize: '14px',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word'
          }}
        >
          {sql ? (
            <code style={{ display: 'block' }}>
              {sql}
            </code>
          ) : (
            <Typography variant='body2' color='text.secondary' sx={{ fontStyle: 'italic' }}>
              Select fields to generate SQL query...
            </Typography>
          )}
        </Paper>
      </Collapse>
    </Box>
  );
};

export default SqlPreviewPanel;
